<template>
  <section class="container p-3 bg-light">
    <div class="row">
      <div class="col-lg-6 offset-lg-3 col-12 p-0">
        <!-- Header -->
        <div class="d-flex justify-content-between">
          <div>
            <div>
              <router-link to="/job-posts">
                <img src="/static/img/main-logo.svg" alt="" width="120">
              </router-link>
            </div>
            <div class="align-self-center pl-3">
              <h3 class="m-0 text-secondary">หางานแม่บ้านประจำ</h3>
            </div>
          </div>
          <div class="d-flex align-items-center">
            <a href="#" class="contact-staff btn-outline-secondary" @click="openModalContactStaff"><i class="fas fa-phone-alt"></i> ติดต่อเจ้าหน้าที่</a>
          </div>

        </div>

        <!-- Search -->
        <div class="pt-3 pb-2" v-if="$route.query.type && $route.query.type === 'saved'">
          งานที่ฉันสนใจ
        </div>
        <div class="row py-3 no-gutters mt-4" v-else>
          <div class="col-lg-4 col-5 pr-2">
            <button class="btn btn-block btn-outline-secondary" @click="loadJobPosts(null)">ดูงานทั้งหมด</button>
          </div>
          <div class="col-lg-8 col-7 pl-2">
            <button class="btn btn-block btn-info" @click="displaySearchModal()">
              <i class="fal fa-search"></i> ค้นหางาน
            </button>
          </div>
        </div>

        <!-- Job Posts -->
        <section class="text-small" v-if="jobPosts && jobPosts.length > 0">
          <div v-for="(jobPost, index) in jobPosts" :key="index">
            <job-post-item :jobPost="jobPost"
                           @onSelected="displayJobPostModal"
            />
          </div>
        </section>
        <section v-else>
          <div class="card">
            <div class="card-body text-center">ไม่มีข้อมูล</div>
          </div>
        </section>
        <div class="p-3 text-center" v-if="searchParams.page > 0 && isLoading">
          <i class="fas fa-spinner fa-pulse"></i> กำลังโหลด...
        </div>
      </div>
    </div>
    <search-modal ref="searchModal" @searchJobPosts="loadJobPosts"></search-modal>
    <job-post-detail-modal ref="jobPostDetailModal"></job-post-detail-modal>

    <sweet-modal ref="contactStaffModal" overlay-theme="dark">
      <section class="main-content bg-light text-left">
        <div class="row">
          <div class="col-12 p-0">
            <h3 class="text-center mt-3 font-weight-bold">บริษัท จัดหางาน บีนีท ฟอร์ บิสซิเนส จำกัด</h3>
            <div style="padding: 15px;">
              <label class="font-weight-bold">เบอร์ติดต่อ</label>
              <ul>
                <li><i class="fas fa-phone-alt"></i> <a href="tel:+66612742888">0612742888  คุณพัชร</a></li>
                <li><i class="fas fa-phone-alt"></i> <a href="tel:+66632970492">0632970492 ป๊อก</a></li>
              </ul>
              <p><img src="/static/img/line-logo.png" class="img-fluid" style="max-height: 24px;"> <span style="font-weight: bold;">ไลน์ไอดี</span> : <a href="https://line.me/R/ti/p/@jobmaid" target="_blank">@jobmaid</a> </p>

              <p class="text-center">
                <img src="/static/img/recruiting/qr_code_line_jobmaid.png" style="max-height: 250px;" class="img-fluid">
              </p>
            </div>
          </div>
        </div>
      </section>
    </sweet-modal>
  </section>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import SearchModal from './SearchModal'
  import JobPostItem from './JobPostItem'
  import JobPostDetailModal from './JobPostDetailModal'
  import { SweetModal } from 'sweet-modal-vue'

  export default {
    components: {
      SearchModal,
      JobPostItem,
      JobPostDetailModal,
      SweetModal
    },
    data () {
      return {
        searchParams: {
          page: 0,
          job_user_id: null
        },
        isLoading: false
      }
    },
    computed: {
      ...mapState('jobPost', ['jobPosts', 'canLoadMore']),
      ...mapState('jobUser', ['jobUser'])
    },
    watch: {
      $route (to, from) {
        this.loadJobPosts(null)
      }
    },
    methods: {
      ...mapActions('jobPost', ['fetchJobPosts', 'fetchJobPostDetail']),
      openModalContactStaff () {
        console.log('clickkk')
        this.$refs.contactStaffModal.open()
      },
      displayJobPostModal (jobPostId) {
        this.$refs.jobPostDetailModal.openModal(jobPostId)
      },
      displaySearchModal () {
        this.$refs.searchModal.displayModal(true)
      },
      async loadJobPosts (params) {
        this.searchParams = {
          page: 0,
          job_user_id: (this.jobUser && this.$route.query.type === 'saved') ? this.jobUser.id : null
        }
        if (params) {
          this.searchParams = {...this.searchParams, ...params}
        }
        await this.fetchJobPosts(this.searchParams)
        this.$refs.searchModal.displayModal(false)
      },
      handleScroll (event) {
        if (((window.innerHeight + window.scrollY) >= document.body.scrollHeight) && this.canLoadMore && !this.isLoading) {
          this.searchParams.page += 1
          this.isLoading = true
          setTimeout(async () => {
            await this.fetchJobPosts(this.searchParams)
            this.isLoading = false
          }, 1000)
        }
      }
    },
    async mounted () {
      if (this.jobUser && this.$route.query.type === 'saved') {
        this.searchParams.job_user_id = this.jobUser.id
      }
      this.loadJobPosts(this.searchParams)
      if (this.$route.query['job-post']) {
        this.displayJobPostModal(this.$route.query['job-post'])
      }
    },
    created () {
      window.addEventListener('scroll', this.handleScroll)
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }
</script>
<style lang="scss">
@import "~bootstrap/scss/_functions.scss";
@import "~bootstrap/scss/_variables.scss";
@import "~bootstrap/scss/mixins/breakpoints";

a.contact-staff {
  border-radius: 11px;
  padding:       10px 25px;
  display:       inline-block;
  text-align:    center;
  box-shadow:    0 2px #cccccc;
  border: 1px solid gray;
}

@include media-breakpoint-down(md) {
  a.contact-staff {
    padding: 5px 15px;
  }
}

section.main-content {
  ul li {
    list-style: none;
    text-align: left;
    margin-top: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/jobPost/JobPost.vue